import React from 'react'
import { SVGProps } from './types'

export const Pencil: React.FC<SVGProps> = ({
  size = 24,
  color = '#404040',
  onClick,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M10.0217 0.667969C10.7328 0.667969 11.4686 1.01979 12.2248 1.77637C13.0513 2.60334 13.395 3.41597 13.3244 4.2041C13.26 4.8452 12.9167 5.49201 12.2258 6.17578L12.2248 6.17676L6.05193 12.3525C5.76203 12.6426 5.21598 12.9192 4.80779 12.9756H4.80681L2.43963 13.3145L2.43181 13.3164C2.3567 13.3337 2.2779 13.334 2.18084 13.334C1.75399 13.334 1.36864 13.1806 1.08904 12.9082C0.758455 12.5767 0.608931 12.0894 0.686697 11.5586V11.5576L1.02361 9.19824V9.19727C1.08 8.7888 1.35678 8.24218 1.64666 7.95215L7.81951 1.77637C8.57553 1.02004 9.31066 0.668056 10.0217 0.667969ZM9.87224 1.4375C9.30921 1.48972 8.82009 1.85178 8.35564 2.3125H8.35467L2.18181 8.48926C2.08512 8.58613 1.99306 8.73199 1.92303 8.87109C1.85303 9.01018 1.79209 9.16933 1.77166 9.30176L1.43377 11.6631V11.6641C1.39715 11.9296 1.44665 12.1935 1.62615 12.373C1.80561 12.5525 2.06878 12.602 2.33416 12.5654H2.33513L4.69353 12.2285L4.69549 12.2275C4.82749 12.2072 4.9886 12.1464 5.12908 12.0762C5.26737 12.007 5.41472 11.9141 5.50994 11.8145L11.6808 5.64062C12.2027 5.11847 12.51 4.62014 12.5558 4.125C12.6112 3.52397 12.2927 2.92488 11.6818 2.30566L11.6808 2.30469C11.0338 1.65736 10.4471 1.38427 9.87224 1.4375Z"
        fill={color}
      />
      <path
        d="M7.10307 2.55046C7.30599 2.49608 7.50987 2.61262 7.56499 2.81315L7.56596 2.81413C8.05557 4.55313 9.43328 5.93251 11.1714 6.42253H11.1734C11.372 6.47729 11.4919 6.68968 11.4351 6.89616L11.4341 6.89812C11.389 7.06778 11.2411 7.17344 11.0718 7.17351C11.0354 7.17351 11.0032 7.16822 10.981 7.16081L10.9761 7.15983L10.9712 7.15788C8.98117 6.59756 7.39863 5.01426 6.83842 3.02312C6.78347 2.82136 6.89807 2.61329 7.10307 2.55046Z"
        fill={color}
      />
    </svg>
  )
}
